import React from 'react';
import {observer} from 'mobx-react';
import './spirit.scss';
import {RenderV2Object} from '../render-v2-d';
import {inchToPx} from '../frame-builder';

type Props = {
    frame: RenderV2Object;
};

type Side = {
    top: boolean;
    left: boolean;
    bottom: boolean;
    right: boolean;
    vertical: boolean;
};

export const Spirit = observer(({frame}: Props) => {
    if (!frame.spiritMode) {
        return;
    }

    const outerSize = 0.3;
    const innerSize = 0.12;
    const doubleInnerSize = innerSize * 2;
    const {railLeft, railRight, railTop, railBottom, spiritMode} = frame;

    const outerSides: Partial<Side>[] = [
        {top: true, left: true},
        {top: true, right: true},
        {bottom: true, left: true},
        {bottom: true, right: true},
        {left: true, vertical: true},
        {right: true, vertical: true},
    ];

    const getOuterSideStyles = (side: Partial<Side>) => {
        const styles: React.CSSProperties = {background: spiritMode?.outerColor};

        if (side.vertical) {
            styles.top = inchToPx(railTop / 2 - doubleInnerSize);
            styles.left = side.left ? inchToPx(railLeft / 2 - doubleInnerSize) : 'auto';
            styles.right = side.right ? inchToPx(railRight / 2 - doubleInnerSize) : 'auto';
            styles.height = `calc(100% - ${inchToPx(railTop / 2 + railBottom / 2 - outerSize - innerSize)})`;
            styles.width = inchToPx(outerSize);
        } else {
            const width = inchToPx(side.left ? railLeft / 2 : railRight / 2);
            const cut = side.top ? spiritMode?.topCutWidth / 2 : spiritMode?.bottomCutWidth / 2;

            styles.top = side.top ? inchToPx(railTop / 2 - doubleInnerSize) : 'auto';
            styles.bottom = side.bottom ? inchToPx(railBottom / 2 - doubleInnerSize) : 'auto';
            styles.height = inchToPx(outerSize);
            styles.width = cut ? `calc(50% - ${width} - ${inchToPx(cut)})` : `50%`;

            if (side.left) {
                styles.left = inchToPx(railLeft / 2 - doubleInnerSize);
            } else {
                styles.right = inchToPx(railRight / 2 - doubleInnerSize);
            }
        }

        return styles;
    };

    const getInnerSideStyles = (side: Partial<Side>) => {
        const styles: React.CSSProperties = {background: spiritMode?.innerColor, zIndex: 1};

        if (side.vertical) {
            styles.height = `calc(100% - ${inchToPx(doubleInnerSize)})`;
            styles.width = inchToPx(innerSize);
        } else {
            styles.height = inchToPx(innerSize);
            styles.marginLeft = side.left ? inchToPx(innerSize) : 'auto';
            styles.marginRight = side.right ? inchToPx(innerSize) : 'auto';
            styles.width = `calc(100% - ${inchToPx(doubleInnerSize)})`;
        }

        return styles;
    };

    return (
        <div className="spirit-container">
            {outerSides.map((side, index) => (
                <div
                    key={index}
                    className="outer"
                    style={getOuterSideStyles(side)}
                >
                    <div
                        className="inner"
                        style={getInnerSideStyles(side)}
                    />
                </div>
            ))}
        </div>
    );
});
